export const selectFlowSteps = (state) => state.flow?.steps;
export const selectCurrentStepKey = (state) => {
    const length = state.flow.steps.length;
    return state.flow?.steps[length - 1]?.key
}
export const selectCurrentStep = (state) => state.flow?.currentStep;
export const selectNextStepPath = (state) => state.flow?.nextStepPath;
export const selectPrevStepPath = (state) => state.flow?.prevStepPath;
export const selectOriginPath = (state) => state.flow?.originPath;
export const selectCurrentFlow = (state) => state.flow?.currentFlow;
